var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6249 7.33464C14.6249 3.32279 11.3451 0.0429688 7.33325 0.0429688C3.32141 0.0429688 0.041584 3.32279 0.041584 7.33464C0.041584 11.3465 3.32141 14.6263 7.33325 14.6263C9.1248 14.6263 10.7428 13.9992 11.9969 12.9587L16.8948 17.78C17.1408 18.0222 17.5365 18.0191 17.7787 17.7731C18.0208 17.5271 18.0177 17.1314 17.7717 16.8892L12.8866 12.0805C13.9757 10.8022 14.6249 9.14182 14.6249 7.33464ZM11.4636 11.7634C11.4886 11.7217 11.5189 11.6823 11.5545 11.6462C11.595 11.6051 11.6398 11.5707 11.6874 11.5432C12.7381 10.4537 13.3749 8.96787 13.3749 7.33464C13.3749 4.01315 10.6547 1.29297 7.33325 1.29297C4.01176 1.29297 1.29158 4.01315 1.29158 7.33464C1.29158 10.6561 4.01176 13.3763 7.33325 13.3763C8.94843 13.3763 10.3926 12.7635 11.4636 11.7634Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyIcon);
export default __webpack_public_path__ + "static/media/magnify-icon.ade4165e0baac788ec714baf8d156773.svg";
export { ForwardRef as ReactComponent };